import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal } from '@angular/core';
import { ScrollService } from 'src/app/services/scroll.service';

@Component({
  selector: 'app-nav-button',
  standalone: true,
  imports: [],
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavButtonComponent {
  public label: InputSignal<string> = input.required();
  public iconName: InputSignal<string> = input.required();
  public active: InputSignal<boolean> = input(false);
  
  private _scrollService = inject(ScrollService);
  
  private _isScrolled = computed(() => this._scrollService.isScrolled());
  get isScrolled() {
    return this._isScrolled();
  } 
}
